import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const StyledWizardCard = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    flex-grow: 1;
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 8px;
    cursor: pointer;
    transition: box-shadow 150ms ease-in;

    &:not(.activeCard):hover {
        box-shadow: 0 18px 34px 0 rgba(14, 30, 62, 0.12);
    }

    &.activeCard {
        border: 2px solid ${colorsPalettes.blue[300]};
        background: ${colorsPalettes.blue[50]};
    }
`;

export const StyledWizardCardTextWrapper = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
    font-feature-settings: 'liga' off, 'clig' off;

    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;

    @media (max-width: 1280px) {
        font-size: 18px;
    }
`;

export const StyledWizardGoalCard = styled(StyledWizardCard)`
    flex-direction: row;
    gap: 24px;
    padding: 10px;
    border: 2px solid ${colorsPalettes.sky[200]};

    @media (max-width: 1280px) {
        padding: 6px;
    }
`;

export const StyledWizardFocusCard = styled(StyledWizardCard)`
    flex-direction: column;
    gap: 20px;
    padding: 24px;
    border: 2px solid ${colorsPalettes.blue[100]};
`;

export const StyledWizardFocusCardIconWrapper = styled.div`
    width: 80px;
    height: 80px;
    padding: 8px;
    box-sizing: border-box;

    & > div {
        width: 100%;
        height: 100%;
    }
`;

export const StyledWizardFocusCardTextWrapper = styled(StyledWizardCardTextWrapper)`
    text-align: center;
`;

export const StyledWizardGoalCardIconWrapper = styled.div`
    width: 56px;
    height: 56px;
    padding: 8px;
    box-sizing: border-box;

    & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;

        &.search-keyword svg {
            width: 30px;
        }

        &.list-icon-gradient svg {
            width: 23px;
        }

        &.refresh-gradient svg {
            width: 35px;
        }

        &.building svg {
            width: 22px;
        }

        &.browser svg {
            width: 32px;
        }
    }

    @media (max-width: 1280px) {
        width: 48px;
        height: 48px;

        & > div {
            &.search-keyword svg {
                width: 24px;
            }

            &.list-icon-gradient svg {
                width: 19px;
            }

            &.refresh-gradient svg {
                width: 27px;
            }

            &.building svg {
                width: 18px;
            }

            &.browser svg {
                width: 25px;
            }
        }
    }
`;